<template>
  <div>
    <base-dialog
      @save-item="saveItem"
      dialogId="edit-mac-address-attribute-dialog"
      :open.sync="openDialog"
      :form-ref.sync="attributeFormRef"
      :loading.sync="isLoading"
    >
      <template v-slot:[`activator.content`]>
        <v-icon>mdi-square-edit-outline</v-icon>
      </template>
      <template v-slot:[`dialog.title`]>
        <span>Editer un adresse MAC</span>
      </template>
      <template v-slot:[`dialog.content`]>
        <v-text-field
          v-model="attributeForm.value"
          label="Adresse MAC"
          :rules="rules.valueRules"
          persistent-hint
          hint="Format 12:34:56:AB:CD:EF ou 12-34-56-AB-CD-EF"
        >
        </v-text-field>
        <v-textarea v-model="attributeForm.comment" label="Commentaire">
        </v-textarea>
        <p>
          Les commentaires sont utilisés pour savoir par qui et pour quelle
          raison l'attribut a été ajouté
        </p>
      </template>
      <template v-slot:[`dialog.actions.save`]>Enregistrer</template>
      <template v-slot:[`dialog.actions.extra`]>
        <v-btn color="error" text @click="openDeleteDialog = true">
          Supprimer
        </v-btn>
      </template>
    </base-dialog>
    <delete-dialog
      :open.sync="openDeleteDialog"
      v-on:delete="triggerDeleteAttribute()"
    >
      <template #title>
        Suppression adresse MAC {{ attributeForm.value }}
      </template>
      Vous êtes sur le point de supprimer cette adresse MAC. Voulez-vous
      continuer ?
    </delete-dialog>
    <loading-dialog v-if="openLoadingDialog">
      <template #loading-text>Suppression</template>
    </loading-dialog>
  </div>
</template>
<script>
import { toRefs, watch, computed, onMounted, ref } from "@vue/composition-api";
import { useAttributes } from "@/composables/attribute";
import BaseDialog from "@/components/General/BaseDialog.vue";
import DeleteDialog from "@/components/General/DeleteDialog.vue";
import LoadingDialog from "@/components/General/LoadingDialog.vue";

export default {
  components: {
    BaseDialog,
    DeleteDialog,
    LoadingDialog,
  },
  props: {
    attribute: Object,
    open: Boolean,
  },
  setup(props, { emit }) {
    /* Import des API */
    const {
      attributeData,
      updateAttribute,
      attributes,
      deleteAttribute,
    } = useAttributes();

    /* Variables */
    const { name, value, comment } = props.attribute;
    const openDeleteDialog = ref(false);
    const openLoadingDialog = ref(false);

    /* Computed */
    const openDialog = computed({
      get: function () {
        return props.open;
      },
      set: function (value) {
        emit("update:open", value);
      },
    });

    /* Watchers */
    watch(
      () => attributes.value,
      function (newValue, oldValue) {
        if (newValue != oldValue && newValue != null) {
          emit("update:attributes", newValue);
        }
      }
    );

    /* Méthodes */
    const saveItem = async function () {
      await updateAttribute(props.attribute, "MAC-ADDRESS");
      openDialog.value = attributeData.editAttributeDialog;
    };
    const triggerDeleteAttribute = async function () {
      openLoadingDialog.value = true;
      await deleteAttribute(props.attribute, "MAC-ADDRESS");
      openLoadingDialog.value = false;
      openDeleteDialog.value = false;
      openDialog.value = false;
    };

    /* Cycle de vie */
    onMounted(() => {
      attributeData.attributeForm = { name, value, comment };
      attributeData.rules.valueRules.push(
        (v) =>
          (v && /^([0-9A-Fa-f]{2}[-:]){5}([0-9A-Fa-f]{2})$/.test(v)) ||
          "format invalide"
      );
    });

    return {
      updateAttribute,
      ...toRefs(attributeData),
      saveItem,
      openDialog,
      openDeleteDialog,
      deleteAttribute,
      triggerDeleteAttribute,
      openLoadingDialog,
    };
  },
};
</script>
